module.exports = __webpack_public_path__ + "static/media/shoe.18903106.svg";